import React from 'react';
import { useIntl } from 'react-intl';
import { SmartLinkStatsBreakdownItem } from 'fym-shared/src/smartlinks/stats';
import { TypedMemo } from '../../common/types';
import { Panel, PanelBody, PanelHead } from '../../music24/components/primitives/Panel';
import styles from './SMLBreakdownPanel.module.scss';

interface SMLBreakdownPanelProps {
  title: string;
  items: SmartLinkStatsBreakdownItem[];
  /** Turns a stored key into something a person reads. */
  formatKey?: (key: string) => string;
}

const SMLBreakdownPanelComponent: React.FC<SMLBreakdownPanelProps> = ({ title, items, formatKey }) => {
  const intl = useIntl();

  return (
    <Panel className={styles.panel}>
      <PanelHead title={title} />
      <PanelBody>
        {items.length === 0 ? (
          <div className={styles.empty}>
            {intl.formatMessage({ id: 'app.sml.stats.breakdown.empty', defaultMessage: 'No data yet.' })}
          </div>
        ) : (
          items.map((item) => (
            <div key={item.key} className={styles.row}>
              <span className={styles.name}>{formatKey ? formatKey(item.key) : item.key}</span>
              <span className={styles.track}>
                <span className={styles.bar} style={{ width: `${item.percentage}%` }} />
              </span>
              <span className={styles.value}>
                {intl.formatNumber(item.percentage / 100, { style: 'percent', maximumFractionDigits: 0 })}
              </span>
            </div>
          ))
        )}
      </PanelBody>
    </Panel>
  );
};

export const SMLBreakdownPanel = TypedMemo(SMLBreakdownPanelComponent);
